import React, {
    useEffect,
    useState,
    useRef,
} from "react";
import {
    Row,
    Col,
} from "../../ui/ot";
import { PieChart, Pie, LabelList } from "recharts"
import {
    ChartConfig,
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
    ChartLegend,
    ChartLegendContent
} from "../../ui/chart"

const PieBasicChart = ({
    //數值類型的key
    chartConfig = {
        visitors: {
            label: "Visitors",
        },
        chrome: {
            label: "Chrome",
            color: "hsl(var(--chart-1))",
        },
        safari: {
            label: "Safari",
            color: "hsl(var(--chart-2))",
        },
        firefox: {
            label: "Firefox",
            color: "hsl(var(--chart-3))",
        },
        edge: {
            label: "Edge",
            color: "hsl(var(--chart-4))",
        },
        other: {
            label: "Other",
            color: "hsl(var(--chart-5))",
        },
    },
    //data
    chartData = [
        { browser: "chrome", visitors: 275, },
        { browser: "safari", visitors: 200, },
        { browser: "firefox", visitors: 187, },
        { browser: "edge", visitors: 173, },
        { browser: "other", visitors: 90, },
    ],
    //X 軸顯示的名稱得key
    xDataKeyArr = ["browser"],  //only one 
    yDataKeyArr = ["visitors"], //only one
    showLabel = true,
    labelType = "inner", //  inner, outer, 未完成功能
    showLegend = true,
}) => {
    return (<Row>
        <Col span={24}>
            {
                xDataKeyArr.map((xDataKey) => (
                    yDataKeyArr.map((yDataKey) => {
                        let chartDataColor = chartData.map((value) => {
                            return {
                                ...value,
                                fill: `var(--color-${value[xDataKey]})`
                            }
                        })
                        return (<ChartContainer
                            config={chartConfig}
                            className="mx-auto   max-h-[300px]"
                        // className="mx-auto aspect-square max-h-[250px] pb-0 [&_.recharts-pie-label-text]:fill-foreground"
                        >
                            <PieChart>
                                <ChartTooltip
                                    cursor={false}
                                    content={<ChartTooltipContent hideLabel />}
                                />
                                <Pie
                                    // label={({ payload, ...props }) => {
                                    //     return (
                                    //         <text
                                    //             cx={props.cx}
                                    //             cy={props.cy}
                                    //             x={props.x}
                                    //             y={props.y}
                                    //             textAnchor={props.textAnchor}
                                    //             dominantBaseline={props.dominantBaseline}
                                    //             fill="hsla(var(--foreground))"
                                    //         >
                                    //             {`${chartConfig[payload[xDataKey] ]
                                    //                     ?.label
                                    //                 } (${payload[yDataKey]})`}
                                    //         </text>
                                    //     )
                                    // }}
                                    outerRadius={80}
                                    data={chartDataColor} dataKey={yDataKey} nameKey={xDataKey}
                                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(1)}%`}

                                >
                                    {showLabel && labelType === "inner" && <LabelList
                                        dataKey={xDataKey}
                                        className="fill-background"
                                        stroke="none"
                                        fontSize={12}
                                        formatter={(value) =>
                                            chartConfig[value]?.label
                                        }


                                    />}


                                </Pie>
                                {showLegend && <ChartLegend
                                    content={<ChartLegendContent nameKey={xDataKey} />}
                                    className="flex-wrap"
                                />}
                            </PieChart>
                        </ChartContainer>
                        )
                    })
                ))
            }
        </Col>

    </Row>)
}
export { PieBasicChart }

